import { render } from "./EditCustomerDialog.vue?vue&type=template&id=29f9f9ab&scoped=true"
import script from "./EditCustomerDialog.vue?vue&type=script&lang=js"
export * from "./EditCustomerDialog.vue?vue&type=script&lang=js"

import "./EditCustomerDialog.vue?vue&type=style&index=0&id=29f9f9ab&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f9f9ab"]])

export default __exports__